
import { Component, Ref, Vue } from 'nuxt-property-decorator';
import type { BodyScrollOptions } from 'body-scroll-lock';
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock';
import Notes from '../side-panel/notes/Notes.vue';
import Bookmarks from '../side-panel/bookmarks/Bookmarks.vue';
import ReadabilitySettings from '@/components/ui/side-panel/ReadabilitySettingsPanel.vue';
import PollySettings from '@/components/ui/side-panel/PollySettings.vue';
import DevelopmentMenu from '@/components/ui/side-panel/DevelopmentMenu.vue';
import { SidePanelMode } from '@/components/ui/side-panel/SidePanelMode';
import SearchMenu from '@/components/ui/search/SearchMenu.vue';
import SidePanelStore from '@/components/ui/side-panel/side-panel.store';
import HeaderOffsetSpacer from '@/components/ui/HeaderOffsetSpacer.vue';

@Component({
  inheritAttrs: false,
  components: {
    HeaderOffsetSpacer,
    ReadabilitySettings,
    Notes,
    Bookmarks,
    PollySettings,
    DevelopmentMenu,
    SearchMenu
  }
})
export default class RightDrawer extends Vue {
  bodyScrollOptions: BodyScrollOptions = {
    reserveScrollBarGap: true
  };

  get spacingHeightIfModeIsSearch(): number {
    return this.mode === SidePanelMode.SEARCH ? 120 : 0;
  }

  get currentComponentName(): string {
    return this.mode.toString().toLowerCase().trim();
  }

  get isSearchMode(): boolean {
    return this.mode === SidePanelMode.SEARCH;
  }

  get isOpen(): boolean {
    return SidePanelStore.rightPanelIsOpen;
  }

  get mode(): SidePanelMode {
    return SidePanelStore.mode;
  }

  get currentComponent() {
    switch (SidePanelStore.mode) {
      case SidePanelMode.NOTES:
        return Notes;
      case SidePanelMode.READABILITY:
        return ReadabilitySettings;
      case SidePanelMode.BOOKMARKS:
        return Bookmarks;
      case SidePanelMode.POLLY:
        return PollySettings;
      case SidePanelMode.SEARCH:
        return SearchMenu;
      case SidePanelMode.DEVELOPMENT:
        return DevelopmentMenu;
    }
    throw new Error('No component with name:' + SidePanelStore.mode);
  }

  @Ref()
  rightDrawerContent: HTMLElement;

  mounted() {
    if (this.$vuetify.breakpoint.smAndDown && this.rightDrawerContent) {
      disableBodyScroll(this.rightDrawerContent, this.bodyScrollOptions);
    }
  }

  beforeDestroy() {
    clearAllBodyScrollLocks();
  }
}
